import React from 'react';
import Layout from '../../../../components/layout';
import MetaData from '../../../../components/meta-data';
import Gallery from '../../../../components/gallery';
import Breadcrumbs from '../../../../components/breadcrumbs';
var PeopleDannyTiljak = function PeopleDannyTiljak(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Danny Tiljak",
        description: 'Photos by Drew Templeton of Danny Tiljak',
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement(Gallery, {
        images: props.data.images
    }));
};
export default PeopleDannyTiljak;
var query = "978024899";
